import React from "react";
import { makeStyles } from "@mui/styles";
import { HeaderMenu } from "../components/Header";
import { MobileWeb } from "../components/mobile/BreakPoint";
import { Theme } from "@mui/material";
import { Footer } from "../components/Footer";
import { MobileFooter } from "../components/mobile/MobileFooter";
import { Typography } from "../components/Typography";
import bis01 from "../asset/3s_bis_01.png";
import bis02 from "../asset/3s_bis_02.png";
import bis03 from "../asset/3s_bis_03.png";
import bis04 from "../asset/3s_bis_04.png";
import bis05 from "../asset/3s_bis_05.png";
import bis06 from "../asset/3s_bis_06.jpg";
import bis07 from "../asset/3s_bis_07.png";
import halfCircleBlue from "../asset/half_circle_blue.png";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "20px auto",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      margin: "0px",
      height: "auto",
    },
  },
  body: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
    borderTop: "1px solid #0000003b",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      margin: "12px 20px",
      borderTop: "none",
    },
  },
  container1: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    marginTop: 50,
    maxWidth: 633,
    width: "100%",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      flexDirection: "column",
      marginTop: 30,
    },
  },
  top_text: {
    position: "relative",
    display: "flex",
    justifyContent: "left",
    color: "#204FA1",
    maxWidth: 1290,
    fontSize: 18,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      fontSize: 18,
      marginTop: 0,
      marginLeft: 50,
      justifyContent: "flex-start",
    },
  },
  textBox1: {
    width: "100%",
    alignSelf: "center",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "100%",
      marginBottom: 20,
      textAlign: "justify",
    },
  },
  subtextBox: {
    marginTop: "20px",
    marginBottom: "20px",
    width: "100%",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      marginTop: "50px",
      marginBottom: "20px",
      fontSize: "13px",
      marginLeft: 20,
    },
  },
  imgBox: {
    position: "relative",
    textAlign: "center",
    width: "100%",
    height: "auto",
    maxWidth: "590px",
    background: "#C4C4C4",
    border: "1px solid #000",
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      maxWidth: 824,
      width: "89%",
      margin: "0px 20px",
    },
  },
  halfCircleBlue: {
    position: "relative",
    bottom: 5,
    right: 30,
    width: 65,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      right: 0,
      bottom: 5,
      marginLeft: 20,
    },
  },
}));

const SSSBisContentPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HeaderMenu />
      <div className={classes.body}>
        <div className={classes.container1}>
          <div className={classes.textBox1}>
            <img
              src={halfCircleBlue}
              alt="blueHalfCircle"
              className={classes.halfCircleBlue}
            />
            <Typography variant="H3" className={classes.top_text}>
              3S-BIS 기능
            </Typography>
            <div className={classes.subtextBox}>
              <li>센터 운영 정보 확인(인건비, 재료비, 관리비 현황 확인)</li>
            </div>
            <img
              src={bis01}
              alt="센터운영정보확인"
              className={classes.imgBox}
            ></img>
          </div>
          <div className={classes.textBox1}>
            <div className={classes.subtextBox}>
              <li>직원별 업무 현황 확인</li>
            </div>
            <img
              src={bis02}
              alt="직원별업무현황확인"
              className={classes.imgBox}
            ></img>
          </div>
          <div className={classes.textBox1}>
            <div className={classes.subtextBox}>
              <li>대상자별 서비스 제공 스케줄링</li>
            </div>
            <img
              src={bis03}
              alt="대상자별서비스제공스케줄링"
              className={classes.imgBox}
            ></img>
          </div>
          <div className={classes.textBox1}>
            <div className={classes.subtextBox}>
              <li>서비스 대상자 현황 확인</li>
            </div>
            <img
              src={bis04}
              alt="서비스대상자현황확인"
              className={classes.imgBox}
            ></img>
          </div>
          <div className={classes.textBox1}>
            <div className={classes.subtextBox}>
              <li>재고 관리 기능</li>
            </div>
            <img
              src={bis05}
              alt="재고관리기능"
              className={classes.imgBox}
            ></img>
          </div>
          <div className={classes.textBox1}>
            <div className={classes.subtextBox}>
              <li>운영 성과 확인 - 원가관리 기능</li>
            </div>
            <img
              src={bis06}
              alt="운영성과확인"
              className={classes.imgBox}
            ></img>
          </div>
          <div className={classes.textBox1}>
            <div className={classes.subtextBox}>
              <li>목표원가 및 목표 이익 관리 기능</li>
            </div>
            <img
              src={bis07}
              alt="목표원가및목표이익관리기능"
              className={classes.imgBox}
            ></img>
          </div>
        </div>
      </div>
      <Footer />
      <div style={{ display: "flex" }}>
        <MobileFooter />
      </div>
    </div>
  );
};

export default SSSBisContentPage;
